module.exports = __webpack_public_path__ + "img/埃力克斯.6737144b.png";